//const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:5001';  //TODO: does not work yet.

// const BACKEND_URL = 'http://167.71.34.32:5001'; // OLD
const BACKEND_URL = 'https://auto-court.online/api';
//const BACKEND_URL = 'http://127.0.0.1:5000'; // (***)

const headers = {
  'Content-Type': 'application/json',
};

const getToken = () => localStorage.getItem('token');

const getRequest = async (endpoint) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const res = await fetch(`${BACKEND_URL}${endpoint}`, {
      mode: 'cors',
      headers,
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  } catch (error) {
    console.error(`GET ${endpoint} failed:`, error);
    return null;
  }
};

const postRequest = async (endpoint, data) => {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };

  try {
    const res = await fetch(`${BACKEND_URL}${endpoint}`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
      mode: 'cors',
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  } catch (error) {
    console.error(`POST ${endpoint} failed:`, error);
    return null;
  }
};

// API calls
export const getBookings = () => getRequest('/get_bookings');
export const getSavedAccounts = () => getRequest('/get_saved_accounts');
export const getBookingConfig = () => getRequest('/get_booking_config');
export const getBannedEmails = () => getRequest('/get_banned_emails');
export const makeBooking = (data) => postRequest('/make_booking', data);
export const getBookingStatus = (data) => postRequest('/get_booking_status', data);
export const deleteBooking = (data) => postRequest('/delete_booking', data);
export const updatePwdHash = (data) => postRequest('/update_pwd_hash', data);
export const updateBookingConfig = (data) => postRequest('/update_booking_config', data);
export const deleteSavedAccount = (data) => postRequest('/delete_saved_account', data);
export const deleteBannedAccount = (data) => postRequest('/delete_banned_account', data);
export const addBannedAccount = (data) => postRequest('/add_banned_account', data);
export const submitLogin = (data) => postRequest('/login', data);